import { css as i } from "@microsoft/fast-element";
import { normalize as e } from "../common/normalize.js";
import { display as n } from "@matrix42/fast-foundation";
import { inputControlStyles as s, inputTextStyles as l } from "../styles/input.styles.js";
import { menuContainerStyles as a } from "../styles/menu.styles.js";
import { designTokens as o } from "../design-tokens.js";
const h = (t) => i`
  ${e}
  ${n("flex")}
  ${s(":host")}
  ${l(".selected-value")}
  ${a(".listbox")}
  :host {
    /* Base */
    position: relative;
    outline: none;
  }

  :host([open]) .listbox {
    /* Base */
    display: flex;
  }

  :host([open]) ::slotted(.open-indicator) {
    /* Base */
    display: none;
  }

  :host([open]) ::slotted(.close-indicator) {
    /* Base */
    display: inline-block;
  }

  .control {
    /* Layout */
    display: flex;
    gap: ${o.spacing[2]};
    width: 100%;
  }

  .listbox {
    /* Base */
    display: none;
    margin-top: calc(1.063 * ${o.spacing[4]});
    position: absolute !important;
    width: 100% !important;
  }

  .indicator {
    /* Base */
    height: ${o.iconSize.md};
  }

  ::slotted(${t.prefix}-icon) {
    /* Layout */
    width: ${o.iconSize.md} !important;
    height: ${o.iconSize.md} !important;
    /* Style */
    color: inherit;
  }

  ::slotted(.close-indicator) {
    /* Base */
    display: none;
  }
`;
export {
  h as listboxStyles
};
